type MCSecurityRiskBannerProps = {
  allowlistMessage?: string | null;
  rateLimitMessage?: string | null;
};

export function MCSecurityRiskBanner({ allowlistMessage, rateLimitMessage }: MCSecurityRiskBannerProps) {
  return (
    <div className="rounded-2xl border border-red-300/70 bg-red-600/10 p-4 text-sm text-red-100">
      <p className="font-semibold uppercase tracking-wide text-red-200">Danger zone</p>
      <p className="mt-1 text-red-100">
        These actions are irreversible and immediately affect production workloads. Double-check tenant + resource IDs
        before continuing.
      </p>
      {allowlistMessage && <p className="mt-2 text-xs text-red-100/80">{allowlistMessage}</p>}
      {rateLimitMessage && <p className="mt-1 text-xs text-red-100/80">{rateLimitMessage}</p>}
    </div>
  );
}

export default MCSecurityRiskBanner;
